export default () => {
	const reminder = document.querySelector('.c-reminder');
	const reminderTrigger = document.querySelector('[data-reminder="trigger"]');
	const reminderInput = document.querySelector('[data-reminder="input"]');
	const reminderFocus = document.querySelector('[data-reminder="focus"]');
	const reminderData = document.querySelector('[data-reminder="data"]');

	if(!reminder && !reminderTrigger && !reminderFocus) return;

	reminderTrigger.setAttribute('aria-expanded', 'false');
	reminderTrigger.setAttribute('aria-controls', reminder.getAttribute('id'));
  
	reminderTrigger.addEventListener('click', function() {
		if (!reminder.classList.contains('c-reminder--show')) {
			reminder.classList.add('c-reminder--show');
			this.setAttribute('aria-expanded', 'true');
		}
		else {
			reminder.classList.remove('c-reminder--show');
			this.setAttribute('aria-expanded', 'false');
		}
	});

	reminderFocus.addEventListener('click', () => { 
		reminderInput.focus();
	});

	reminderInput.addEventListener('keyup', (e) => { 
		reminderData.innerHTML = e.target.value;
	});
};